<app-search
  [placeholder]="placeholder | translate"
  [label]="label"
  [isRequired]="isRequired"
  (changeValue)="subject$.next($event)"
  [template]="list"
  [stopLoader]="stopLoader"
  (fieldCleared)="clearData()"
  [value]="value"
  [isError]="isError"
  [errorMessage]="errorMessage | translate"
  [description]="description"
  [isDisabled]="disabled"
></app-search>
<ng-template #list>
  <div class="owners-list-wrapper" *ngIf="(ownersList$ | async).length">
    <div class="owners-list">
      <div class="owners-list-item" *ngFor="let owner of ownersList$ | async">
        <div [class.disabled]="owner.isAlreadyAdded" (click)="select(owner)">
          <p>
            {{ owner?.firstName }} {{ owner?.lastName }}
            <i class="icon-external-link-default-14" *ngIf="isExternal" [style.margin-left]="'5px'" [style.cursor]="'pointer'"></i>
          </p>
          <p>{{ owner?.title }}, {{ owner?.homeBuildingName }}</p>
        </div>
        <i
          class="icon-information-16"
          [appTooltip]="'Translation.Already_added' | translate"
          [tooltipPosition]="'topRight'"
          *ngIf="owner.isAlreadyAdded"
        ></i>
      </div>
    </div>
    <div class="no-result-found" *ngIf="(ownersList$ | async).length >= overflowLimit">
      {{ "Translation.Foundtoomanymatches" | translate }}
    </div>
  </div>
  <div class="no-result-found" *ngIf="noResultFound">
    {{ "Translation.No_results_found" | translate }}
  </div>
</ng-template>
<div *ngIf="showChips && chips?.length" class="mt-4">
  <app-tags>
    <app-tag
      *ngFor="let chip of chips; let i = index"
      [isRemovable]="true"
      (removed)="remove(i)"
      [isDisabled]="disabled"
      [label]="chip?.firstName + ' ' + chip?.lastName"
    >
    </app-tag>
  </app-tags>
</div>
